import {
  useCallback,
  useEffect,
  useRef,
  useState,
} from 'react';
import { STORY_DETAIL_LIST_PROGRESS_INTERVAL } from '#advertStory/constants';
import { UseProgressIntervalResultType } from '#advertStory/detail-list';

const useProgressInterval = (): UseProgressIntervalResultType => {
  const [progress, setProgress] = useState<number>(0);
  const refProgressIntervalId = useRef<NodeJS.Timeout | null>(null);

  const stopProgressInterval = useCallback((clearProgress = true): void => {
    if (!refProgressIntervalId.current) {
      return;
    }

    clearTimeout(refProgressIntervalId.current);
    if (clearProgress) {
      setProgress(0);
    }
  }, []);

  const startProgressInterval = useCallback((clearProgress = true): void => {
    stopProgressInterval(clearProgress);
    refProgressIntervalId.current = setInterval(() => {
      setProgress((currentProgress): number => currentProgress + STORY_DETAIL_LIST_PROGRESS_INTERVAL);
    }, STORY_DETAIL_LIST_PROGRESS_INTERVAL);
  }, [stopProgressInterval]);

  useEffect(() => {
    startProgressInterval();

    return () => {
      stopProgressInterval();
    };
  }, [startProgressInterval, stopProgressInterval]);

  return {
    progress,
    stopProgressInterval,
    startProgressInterval,
  };
};

export { useProgressInterval };
